import ConfirmOrderSuccess from './ConfirmOrderSuccess'

export default ConfirmOrderSuccess
